import Backstage from './Backstage.interface';
import { FollowData } from './Follow.interface';
import { NftType } from './NftData.interface';
import { Notification } from './Notification.interface';
import { SubscribeData } from './Subscribe.interface';
import { Transaction } from './Transaction.interface';

export enum UserPlatform {
  MARKETING = 'marketing',
  CLIENT = 'client',
}
export interface UserData {
  id: number;
  name: string;
  address: string;
  avatar?: string;
  banner?: string;
  bio?: string;
  username: string;
  email: string;
  facebook?: string;
  featured: boolean;
  seenOnBoarding: boolean;
  lastOnline?: string;
  order: number;
  platform: string;
  role: string;
  canPost: boolean;
  isCreator: boolean;
  walletAddress: string;
  instagram?: string;
  twitter?: string;
  tiktok?: string;
  verified: boolean;
  website?: string;
  backstageDesc: string;
  followers: FollowData[];
  following: FollowData[];
  subscribedTo: SubscribeData[];
  subscribers: SubscribeData[];
  invites: number;
  transactionsSent: Transaction[];
  transactionsReceived: Transaction[];
  backstagesSplit?: Backstage[];
  notificationsReceived: Notification[];
  notificationsSent: Notification[];
  isTopFeatured: boolean;
  subscriptionPrice: string;
  isOnTrial: boolean;
  trialDuration: Date | null;
  discountedSubscriptionPrice: string | null;
  numberOfSales: number;
  uniqueUrl: boolean;
  preferredCategories: NftType[];
  tatumUserId?: string;
  tatumWalletAddress?: string;
  requestedCreatorAccess: boolean;
}
export interface UserFormData {
  name: string;
  username: string;
  email: string;
  password: string;
  walletAddress: string;
  platform: string;
  address?: string;
  seenOnBoarding?: boolean;
  torusWalletId?: string;
}

export interface UserProfileData {
  id?: number;
  name: string;
  bio?: string;
  username: string;
  email: string;
  address: string;
  walletAddress: string;
  instagram: string;
  twitter: string;
  avatar: string;
  banner: string;
  verified: boolean;
  website: string;
  facebook: string;
  tiktok: string;
  platform: UserPlatform;
  seenOnBoarding: false;
  canPost: boolean;
  backstageDesc: string;
  followers: FollowData[];
  following: FollowData[];
  subscribers?: SubscribeData[];
}

export interface IUserPersonalData {
  realName: string;
  address: string;
  dateOfBirth?: Date;
  phone: string;
  postalCode: string;
  city: string;
  idPictures: File[];
}
